import React, { useState } from "react";
import emailjs from "@emailjs/browser";
import { toast } from "react-toastify";
import "./Contact.css";

export default function Contact() {
  const [form, setForm] = useState({
    from_name: "",
    from_email: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);

  // 🔥 EmailJS IDs
  const SERVICE_ID = "service_ktwi3wj";
  const TEMPLATE_ID = "template_0r2xgx4";
  const PUBLIC_KEY = "-eACg0KZFD9Bkm6XD";

  // 🟦 שינוי שדות
  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  // 🟦 שליחת הטופס
  const handleSubmit = (e) => {
    e.preventDefault();

    if (!form.from_name || !form.from_email || !form.message) {
      toast.error("Please fill out all fields.");
      return;
    }

    setLoading(true);

    emailjs
      .send(SERVICE_ID, TEMPLATE_ID, form, PUBLIC_KEY)
      .then(() => {
        toast.success("Message sent successfully!");
        setForm({ from_name: "", from_email: "", message: "" });
      })
      .catch((err) => {
        console.error(err);
        toast.error("Failed to send message. Try again later.");
      })
      .finally(() => setLoading(false));
  };

  return (
    <div className="contact-wrapper">
      <div className="contact-card">
        <h2>Contact Us</h2>
      <p>
  Have a question about Lutology products? We're here to help.
  <br />
  You can also reach us directly at{" "}
  <a href="mailto:lutology.team@gmail.com" className="contact-email">
    lutology.team@gmail.com
  </a>
</p>

        <form onSubmit={handleSubmit} className="contact-form">
          <input
            type="text"
            name="from_name"
            placeholder="Your name"
            value={form.from_name}
            onChange={handleChange}
            className="contact-input"
            required
          />

          <input
            type="email"
            name="from_email"
            placeholder="Your email"
            value={form.from_email}
            onChange={handleChange}
            className="contact-input"
            required
          />

          <textarea
            name="message"
            placeholder="Write your message..."
            value={form.message}
            onChange={handleChange}
            className="contact-textarea"
            required
          />

          <button type="submit" className="contact-button" disabled={loading}>
            {loading ? "Sending..." : "Send Message"}
          </button>
        </form>
      </div>
    </div>
  );
}
